import { FC, useContext, useEffect, useState } from "react";
import "./BlogPageStyles.scss";
import BlogPostEntity from "../../../../../domain/entities/BlogPostEntity";
import di from "../../../../../di/DependencyInjection";
import GetAllBlogsAndMainPostUseCase, {
    GetAllBlogsAndMainPostUseCaseName,
} from "../../../../../domain/use_cases/blog/GetAllBlogsAndMainPostUseCase";
import ModalsContext from "../../../../../domain/providers/modal/ModalsContext";
import ModalsContextType from "../../../../../domain/providers/modal/ModalsContextType";
import Layout from "../../../layout/Layout";
import Icons from "../../../assets/Icons";
import DateParse from "../../../../utils/DateParse";
import CardBlogComponent from "./components/CardBlogComponent";
import { Link } from "react-router-dom";
import { routes } from "../../../routes/RoutesComponent";
import HostApi from "../../../../../data/settings/HostApi";
import BlogPostImplDto from "../../../../../data/dto/impl/BlogPostImplDto";
import Button from "../../../components/Button";
import { useForm } from "react-hook-form";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { SkeletonCard } from "../../../components/skeletonCard/skeletonCard";

const BlogPage: FC<{}> = () => {
    const { addToast } = useContext(ModalsContext) as ModalsContextType;
    const { register, handleSubmit, setValue } = useForm();
    const [maxPages, setMaxPages] = useState<number>(1);
    const [page, setPage] = useState<number>(1);

    const [blogs, setBlogs] = useState([]);
    const [outstandingBlog, setOutstandingBlog] = useState(undefined);
    const [filterByTag, setFilterByTag] = useState([]);
    const [tag, setTag] = useState("");

    const _loadBlogs = async () => {
        try {
            setBlogs([]);
            const response = await HostApi.get("/post?page=" + page);
            // const blogsData = await response.blogs.map((blog: any) => BlogPostImplDto.fromJson(blog));
            const blogsData = await response.blogs;
            const mainPostData = await response.main_post;
            const dataTags = blogsData.map((data: any) => data?.tagName?.toLowerCase());
            const tags = new Set(dataTags);
            setFilterByTag([...tags]);
            const activeBlogs = blogsData.filter((blog: any) => blog.active === true);
            setBlogs(activeBlogs);
            setMaxPages(response.num_pages);

            setOutstandingBlog(mainPostData);
        } catch (error) {
            addToast("Error al obtener los posts", "error", undefined);
        }
    };

    useEffect(() => {
        _loadBlogs();
    }, []);

    const _handleNextPage = async () => {
        const nextPage = page + 1;
        setPage(nextPage);
        document.querySelector(".content_app").scrollTo({
            top: 0,
            behavior: "smooth",
        });
        _loadBlogs();
    };

    const _handlePreviousPage = async () => {
        const previousPage = page - 1;
        setPage(previousPage);
        document.querySelector(".content_app").scrollTo({
            top: 0,
            behavior: "smooth",
        });
        _loadBlogs();
    };

    const _handleChangePage = async (page: number) => {
        const previousPage = page;
        setPage(previousPage);
        document.querySelector(".content_app").scrollTo({
            top: 0,
            behavior: "smooth",
        });
        _loadBlogs();
    };

    return (
        <div className="blog_page">
            <Layout>
                {outstandingBlog && (
                    <section className="section_1">
                        <img
                            src={outstandingBlog?.photoUrl}
                            alt={outstandingBlog?.title}
                            title={outstandingBlog?.title}
                            className="img-fluid object_cover w-100 outstandingBlog-main-image"
                        />
                        <div className="container">
                            <div className="outstanding_blog">
                                <div className="row">
                                    <Link
                                        to={
                                            routes.detailedBlog.relativePath +
                                            `/${
                                                outstandingBlog.url_post
                                                    ? outstandingBlog.url_post.replace(/ /g, "-")
                                                    : outstandingBlog.title.replace(/ /g, "-")
                                            }?id=${outstandingBlog.id}`
                                        }
                                        className="col-md-6 ms-md-5"
                                    >
                                        <div className="bg_white outstanding_container p-4">
                                            <h1 className="my-2 text_bold outstanding-title">
                                                {outstandingBlog?.title}
                                            </h1>
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 blog_info_user">
                                                    {/* <img
                                                        src={
                                                            outstandingBlog?.user?.photo ||
                                                            "https://images.unsplash.com/photo-1506863530036-1efeddceb993?auto=format&fit=crop&q=80&w=1944&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                                        }
                                                        alt="wcar"
                                                        title="wcar"
                                                        style={{ width: "36px", height: "36px", objectFit: "cover" }}
                                                        className="img_rounded me-2"
                                                    />
                                                    <span className="text_gray text_bold" style={{ fontSize: "14px" }}>
                                                        {outstandingBlog?.user?.name || ""}
                                                    </span> */}
                                                    <span className="text_gray date">
                                                        {new Intl.DateTimeFormat("es-ES", {
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "numeric",
                                                        }).format(new Date(outstandingBlog.created_at))}
                                                    </span>
                                                </div>
                                                <div className="text_orange">
                                                    <Icons.ArrowCircle width={60} />
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                <section className="section_2 pb-5 mt-3">
                    <div className="container">
                        <h5 className="text_bold last-articles-title">Últimos artículos</h5>
                        <form
                            className="d-flex gap-3 flex-wrap justify-content-center justify-content-md-between"
                            onSubmit={handleSubmit((data: any) => setTag(data.filter))}
                        >
                            <div className="d-flex gap-3 filter">
                                <select
                                    className="form-select"
                                    {...register("filter")}
                                    style={{ maxWidth: "400px", textTransform: "capitalize" }}
                                >
                                    <option value="">Todos</option>
                                    {filterByTag?.map((tag, i) => {
                                        return (
                                            <option value={tag} key={i}>
                                                {tag}
                                            </option>
                                        );
                                    })}
                                </select>
                                <Button label="Filtrar" width="110px" type="submit" />
                            </div>
                            <Button
                                variant="black"
                                label="Sala de Prensa"
                                width="170px"
                                onClick={() => {
                                    setTag(tag === "prensa" ? "" : "prensa");
                                    setValue("filter", tag === "prensa" ? "" : "prensa");
                                }}
                            />
                        </form>
                        <div className="row">
                            {blogs.map((blog, index) => {
                                if (
                                    tag === "" ||
                                    tag === blog?.tagName?.toLowerCase() ||
                                    (tag === "prensa" && blog?.id === 50)
                                ) {
                                    return (
                                        <div className="col-md-4 col-lg-3 my-3" key={index}>
                                            <CardBlogComponent blog={blog} />
                                        </div>
                                    );
                                }
                            })}
                        </div>

                        <div className="row">
                            {blogs.length == 0 &&
                                Array.from({ length: 24 }).map((_, i) => (
                                    <>
                                        <div className={"col-md-4 col-lg-3 my-3"} key={i}>
                                            <SkeletonCard blog={true} />
                                        </div>
                                    </>
                                ))}
                        </div>
                        {maxPages > 1 && (
                            <>
                                <div className="w-100 d-flex justify-content-center align-items-center my-3">
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            <div
                                                className={`arrow_slider previous me-1 mt-1 ${
                                                    page <= 1 ? "disabled" : ""
                                                }`}
                                            >
                                                <AiOutlineArrowLeft size={20} onClick={_handlePreviousPage} />
                                            </div>
                                            {/* <li className="page-item">
                                                    <a className="page-link " href="#" aria-label="Previous">
                                                        <span aria-hidden="true">&laquo;</span>
                                                    </a>
                                                </li> */}
                                            {Array.from({ length: maxPages }, (_, index) => (
                                                <li key={index}>
                                                    <a
                                                        // className="page-link"
                                                        className={` page-link ${
                                                            page === index + 1 ? "active-custom" : ""
                                                        }`}
                                                        style={{
                                                            color: page === index + 1 ? "white" : "#FF7300",
                                                        }}
                                                        href="#"
                                                        onClick={() => _handleChangePage(index + 1)}
                                                    >
                                                        {index + 1}
                                                    </a>
                                                </li>
                                            ))}

                                            <div
                                                className={`arrow_slider next mt-1 ms-1 ${
                                                    page >= maxPages ? "disabled" : ""
                                                }`}
                                            >
                                                <AiOutlineArrowRight size={20} onClick={_handleNextPage} />
                                            </div>
                                        </ul>
                                    </nav>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default BlogPage;
